<template>
	<div class="paddBottom">
		<IndexHeaderOthers subName="Message" ref="indexHeader" />
		<div class="main">
			<div class="conner">
				<div class="h1">{{messageTitle}}</div>
				<div class="desc" style="margin-bottom: 20px;">
					{{messageDesc}}
				</div>
				<div class="conner-middle">
					<div class="content-input" v-show="showContentInput">
						<div class="content-input-left">
							<div class="content-checkbox">
								<p style="margin: 18px 0;width: 86px;">Telescope :</p>
								<div class="groupAllList" style="flex:1">
									<div class="listAll" v-for="(item, index) in Telescopes" :key="index">
										<!-- <el-checkbox v-model="item.checkAll" @change="handleCheckAllChange(item)" class="checkAll">
											{{ item.name }}
										</el-checkbox> -->
										<div class="checkAll">
											{{ item.name }}
										</div>
										<el-checkbox-group v-model="item.checked" @change="handleCheckedChange(item)" style="flex: 1">
											<el-checkbox v-for="(item2, index2) in item.children" :label="item2.name" :key="index2"
												:value="item.name">{{ item2.name }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
								</div>
							</div>
							<div class="content-input-left-top">
								<div class="top-left" style="display: flex;">
									<div class="topP">Coordinate :</div>
									<div style="display: flex;margin-left: 6px;margin-top: 14px;">
										<div style="width: 200px;display: flex;flex-direction: column;align-items: left;">
											<el-input v-model="ra" placeholder="RA"></el-input>
											<span style="font-size: 12px;width: 150px;text-align: left;padding-left: 12px;color: rgba(0,0,0,0.5);">(e.g., 350.1234)</span>
										</div>
										<div style="width: 200px;margin-left: 8%;display: flex;flex-direction: column;align-items: left;">
											<el-input v-model="dec" placeholder="DEC"></el-input>
											<span style="font-size: 12px;width: 150px;text-align: left;padding-left: 12px;color: rgba(0,0,0,0.5);">(e.g., -17.3333)</span>
										</div>
									</div>
								</div>
								<div class="top-right">
									<p>Search Radius :</p>
									<el-input v-model="radius" placeholder="">
										<span slot="suffix"> deg </span>
									</el-input>
								</div>
							</div>
							<div class="content-input-left-footer">
								<div class="content-input-left-footer-top">
									<h1>Trigger Time :</h1>
									<el-date-picker v-model="beginTriggerTime" type="date" value-format="yyyy-MM-dd" placeholder="From date"
										:picker-options="pickerOptions0">
									</el-date-picker>
									<div class="to">to</div>
									<el-date-picker v-model="endTriggerTime" type="date" value-format="yyyy-MM-dd" placeholder="End date"
										:picker-options="pickerOptions1">
									</el-date-picker>
								</div>
								<div class="content-input-left-footer-bottom">
									<p>Name :</p>
									<el-input v-model="title" placeholder=""></el-input>
								</div>
							</div>
						</div>
						<div class="content-input-right">
							<button class="content-input-right-footer" @click="serach">Search</button>
							<button class="content-input-right-top" @click="reset">Reset</button>
						</div>
					</div>
					<div class="content-input2" v-show="!showContentInput">
						<div class="content-input-left">
							<div class="content-checkbox2">
								<p style="margin: 18px 0;width: 86px;">Telescope :</p>
								<div class="groupAllList">
									<div class="listAll" v-for="(item, index) in Telescopes" :key="index">
										<!-- <el-checkbox v-model="item.checkAll" @change="handleCheckAllChange(item)" class="checkAll">
											{{ item.name }}
										</el-checkbox> -->
										<div class="checkAll">
											{{ item.name }}
										</div>
										<el-checkbox-group v-model="item.checked" @change="handleCheckedChange(item)" style="flex: 1">
											<el-checkbox v-for="(item2, index2) in item.children" :label="item2.name" :key="index2"
												:value="item.name">{{ item2.name }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
								</div>
							</div>
						</div>
						<div class="content-input-right2">
							<div>
								<div class="content-input-right-footer2">
									<button class="content-input-right-footer" style="margin-bottom: 0;" type="primary" round @click="serach">Search</button>
								</div>
							</div>
						</div>
					</div>
					<el-button plain class="showBtn" @click="showBox" v-show="!showContentInput"> <i class="el-icon-arrow-down"></i> Open more options!</el-button>
					<el-button plain class="showBtn" @click="showBox" v-show="showContentInput"> <i class="el-icon-arrow-up"></i> Close more options!</el-button>
				</div>
				<Message ref="message"></Message>
			</div>
		</div>
	</div>
</template>
<script>
	import IndexHeaderOthers from "../components/header/indexHeaderOthers.vue";
	import Message from "../components/page/Message";
	export default {
		// eslint-disable-next-line vue/multi-word-component-names
		name: "message",
		components: {
			IndexHeaderOthers,
			Message
		},
		
		data() {
			return {
				showContentInput:false,
				checkListAll: [
				],
				checkListAll2:[],
				checkListAll3:[],
				ra: "",
				dec: "",
				beginTriggerTime: "",
				endTriggerTime: "",
				title: "",
				radius: "",
				telescope: [],
				Telescopes:'',
				pickerOptions0: {
					disabledDate: (time) => {
						// if (this.endTriggerTime) {
						//     return time.getTime() > new Date(this.endTriggerTime).getTime();
						// }else{
						//     return time.getTime() >= Date.now()
						// } 
						const start = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
							1000 - 1);
						return  time.getTime() >
							new Date().getTime() + (start - new Date().getTime());

					}
				},
				pickerOptions1: {
					disabledDate: (time) => {
						// const start = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
						// 	1000 - 1);
						// return time.getTime() < new Date().getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() >
						// 	new Date().getTime() + (start - new Date().getTime());
							const start = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
								1000 - 1);
							return  time.getTime() >
								new Date().getTime() + (start - new Date().getTime());
						// if(this.beginTriggerTime){
						//   return time.getTime() < new Date(this.beginTriggerTime).getTime() - 1*24*60*60*1000;//����ѡ��ͬһ��
						// }
					}
				},
				messageTitle:'',
				messageDesc:''
			};
		},
		mounted() {
			window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
			this.messageDesc = JSON.parse(localStorage.getItem('columnDetail')).messageDesc.description
			this.messageTitle = JSON.parse(localStorage.getItem('columnDetail')).messageTitle.description
			console.log(this.$refs.message.activeName)
		},
		methods: {
			showBox(){
				this.showContentInput = !this.showContentInput
				if(!this.showContentInput){
					this.Telescopes = this.checkListAll2
					console.log(this.Telescopes)
				}else{
					this.Telescopes = this.checkListAll3
				}
			},
			reset() {
				this.ra = "";
				this.dec = "";
				this.beginTriggerTime = "";
				this.endTriggerTime = "";
				this.title = "";
				this.radius = "";
				this.telescope = [];
				let json = {
					telescope: this.telescope,
					ra: this.ra,
					declination: this.dec,
					beginTriggerTime: this.beginTriggerTime,
					endTriggerTime: this.endTriggerTime,
					title: this.title,
					positioningError:this.radius,
					pageNo: 1,
					pageSize: 10,
				};
				this.$refs.message.getDataParm2(json)
			},
			serach() {
				let telescope = []
				for(var i = 0; i < this.telescope.length; i++){
					telescope.push(this.telescope[i].name)
				}
				var c = [];
				for (var i = 0; i < this.Telescopes.length; i++) {
					for (var j = 0; j < this.Telescopes[i].checked.length; j++) {
						c.push(this.Telescopes[i].checked[j]);
					}
				}
				console.log(c)
				telescope = c.join(",");
				let json = {
					telescope: telescope,
					ra: this.ra,
					declination: this.dec,
					beginTriggerTime: this.beginTriggerTime,
					endTriggerTime: this.endTriggerTime,
					title: this.title,
					positioningError:this.radius,
					pageNo: 1,
					pageSize: 10,
				};
				if(this.ra != ''  && this.dec != '' && this.beginTriggerTime != '' && this.endTriggerTime != '' && this.radius != ''){
					this.$refs.message.getDataParm2(json);
					return false
				}
				if(this.ra == ''  && this.dec == '' && this.beginTriggerTime == '' && this.endTriggerTime == '' && this.radius == ''){
					this.$refs.message.getDataParm2(json);
				}else{
					if(this.endTriggerTime != '' && this.beginTriggerTime != ''){
						if(this.ra == ''  && this.dec == '' && this.radius == ''){
							this.$refs.message.getDataParm2(json);
						}else{
							this.$message.error('ra, dec, error, Trigger Time must be enter');
						}
					}else{
						if(this.ra == ''  || this.dec == '' || this.radius == ''){
							this.$message.error('ra, dec, error, Trigger Time must be enter');
						}else{
							// if(this.endTriggerTime == '' || this.beginTriggerTime == ''){
							// 	this.$message.error('Trigger Time must be enter');
							// }
						}
					}
					if(this.ra != ''  && this.dec != '' && this.radius != '' && (this.beginTriggerTime == '' || this.endTriggerTime == '')){
						this.$message.error('ra, dec, error, Trigger Time must be enter');
					}
				}
				
			},
			handleCheckAllChange(val) {
				console.log(val);
				for (var i = 0; i < val.children.length; i++) {
					if (val.checkAll == true) {
						val.checked.push(val.children[i].name);
					} else {
						val.checked = [];
					}
				}
			},
			handleCheckedChange(val) {
				console.log(val);
				let checkedCount = val.checked.length;
				val.checkAll = checkedCount === val.children.length;
			},
			getData() {
				this.$fetchGet("/cms-middle/astronTag/all", {
					type: "telescope",
				}).then((res) => {
					// this.Telescopes = res.data.telescope
					for (var i = 0; i < res.data.telescope.length; i++) {
						this.$set(res.data.telescope[i], "checked", []);
						this.$set(res.data.telescope[i], "checkAll", false);
					}
					for (let i = 0; i < res.data.telescope.length; i++) {
						for(var j = 0; j < res.data.telescope[i].children.length; j++){
							this.checkListAll.push(res.data.telescope[i].children[j]);
						}
					}
					this.checkListAll3 = res.data.telescope
					this.checkListAll2.push(res.data.telescope[0])
					// this.CircularsList = res.page.records;
					// if(!this.showContentInput){
						this.Telescopes = this.checkListAll2
						console.log(this.Telescopes)
					// }else{
					// 	this.Telescopes = this.checkListAll3
					// }
				});
				//   this.getTableData()
			},
		},
		created() {
			this.getData();
		},
	};
</script>
<style>
	.listAll .el-checkbox__label,
	.groupList .el-checkbox__label,
	.subscribed .el-checkbox__label {
		padding-left: 5px !important;
	}
	
	.listAll .el-checkbox,
	.subscribed .el-checkbox {
		height: 40px;
		margin-right: 16px !important;
	}
</style>
<style scoped lang="less">
	/deep/ .el-input__suffix{
		line-height: 33px!important;
	}
	.listAll {
		display: flex;
		padding: 5px 0;
		/* align-items: center; */
		font-size: 14px !important;
		text-align: left;
	}
	.checkAll {
		width: 75px;
		font-weight: 400;
		color: #333333;
		text-align: left;
		color:#168ec7
	}
	.groupAllList,
	.searchALL {
		margin: 15px;
	}
	.groupAllList{
		min-height: 400px;
	}
	.showBtn{
		// margin-top: 20px;
		border-top: none;
		border-radius: 0;
		width: 200px;
		height: 30px;
		padding: 0;
		line-height: 30px;
	}
	.conner-middle{
		// width: 1050px;
		
		text-align: center;
	}
	.main {
		position: relative;
		margin-top: -70px;
		z-index: 99;
		width: 100%;
		height: auto;
		background: #fff;
		border-radius: 0 120px;
	}

	.conner {
		min-width: 1050px;
		width: 73%;
		margin: 0 auto;
		text-align: left;
	}

	.h1 {
		height: 23px;
		font-size: 20px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #168ec7;
		line-height: 23px;
		padding-top: 37px;
		padding-bottom: 18px;
	}

	.content-input {
		margin-top: 32px;
		// height: 210px;
		display: flex;
	}
	.content-input2 {
		margin-top: 32px;
		height: 52px;
		display: flex;
		border-bottom: 1px solid #e6ebf3;
	}
	.content-checkbox {
		border-top: 1px solid #e6ebf3;
		// min-height: 51px;
		display: flex;
		// align-items: baseline;
		// flex-wrap: wrap;
		flex: 1;
	}
	
	.content-checkbox2 {
		border-top: 1px solid #e6ebf3;
		border-bottom: 1px solid #e6ebf3;
		// min-height: 51px;
		display: flex;
		// align-items: center;
		// flex-wrap: wrap;
		flex: 1;
	}
	
	.content-checkbox>p {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}
	
	.content-checkbox2>p {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}

	.el-checkbox-group {
		margin-left: 15px;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #008dc9;
		border-color: #008dc9;
	}

	/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #666666;
	}

	/deep/ .el-checkbox__label {
		padding-left: 6px;
		font-size: 13px;
	}

	.content-input-left {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.content-input-left-top {
		border-top: 1px solid #e6ebf3;
		border-bottom: 1px solid #e6ebf3;
		height: 76px;
		display: flex;
	}

	.top-left {
		display: flex;
		align-items: center;
	}

	.top-left>p {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}
	.topP{
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
		height: 76px;
		line-height: 76px;
	}

	/deep/.content-input .el-input>.el-input__inner {
		border-radius: 20px !important;
		height: 33px !important;
		text-align: center;
		line-height: 33px !important;
	}

	/deep/ input::input-placeholder {
		text-align: center;
	}

	/deep/ input::-ms-input-placeholder {
		text-align: center;
	}

	/deep/ input::-webkit-input-placeholder {
		text-align: center;
	}

	.top-left>.el-input {
		width: 193px;
		height: 33px;
		margin-left: 15px;
	}

	/deep/.content-input .el-input>.el-input__inner {
		border-radius: 20px !important;
		/* text-align: center !important; */
		height: 33px;
		line-height: 33px;
	}

	.top-right {
		flex: 1;
		margin-left: 15px;
		display: flex;
		align-items: center;
	}

	.top-right>p {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}

	.top-right>.el-input {
		width: 287px;
		height: 33px;
		margin-left: 8px;
	}

	.content-input-left-footer {
		height: 79px;
		border-bottom: 1px solid #e6ebf3;
		display: flex;
		align-items: center;
	}

	.content-input-left-footer-top {
		display: flex;
	}

	.content-input-left-footer-top>h1 {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}

	.content-input-left-footer-top>.el-input {
		margin-left: 5px;
		width: 193px !important;
		height: 33px;
	}

	.content-input-left-footer-top>.to {
		margin-left: 5px;
		line-height: 35px;
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: 400;
		color: #666666;
	}

	.content-input-left-footer-bottom {
		display: flex;
		margin-left: 41px;
	}

	.content-input-left-footer-bottom>p {
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
	}

	.content-input-left-footer-bottom>.el-input {
		width: 308px;
		height: 33px;
		margin-left: 8px;
		margin-top: 4px;
	}

	/deep/ .el-input__prefix>.el-input__icon {
		color: #168ec7 !important;
		font-weight: bold;
		line-height: 33px;
	}

	.content-input-right {
		width: 113px;
		// height: 210px;
		background: #f3f5f9;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}
	.content-input-right>button{
		width: 93px;
	}
	.content-input-right2 {
		width: 113px;
		height: 52px;
		background: #f3f5f9;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.content-input-right-top {
		// width: 83px;
		// height: 33px;
		// background: #e6ebf3;
		// border-radius: 17px;
		// margin: 0 auto;
		// cursor: pointer;
		margin-left: 0px;
		border-radius: 20px;
	}
	
	.content-input-right-footer2 {
		margin-bottom: 0px;
	}
	

	.tabList {
		display: flex;
		height: 41px;
		margin-top: 32px;
	}

	.tab {
		flex: 1;
		border: 1px solid #e5e5e5;
		border-radius: 6px;
		text-align: center;
		line-height: 38px;
		font-size: 16px;
		font-family: Arial-Bold, Arial;
		font-weight: bold;
		cursor: pointer;
	}

	.tab.isActive {
		background: linear-gradient(90deg, #144072, #1680b7);
		border-radius: 6px;
		opacity: 1;
		border: 1px solid #ffffff;
		color: #fff;
	}

	.eventstable {
		margin-top: 26px;
	}

	/deep/ .el-table__header-wrapper {
		border-top: 3px solid #168ec7;
		/* height: 42px; */
		background: #f0f3f8 !important;
	}

	/deep/ .el-table__cell {
		// text-align: center;
		font-size: 11px;
		font-family: Alibaba Sans;
	}

	/deep/.el-table tr:nth-child(even) {
		background: #f7f9fb;
	}

	/deep/ .is-leaf {
		font-size: 14px;
		color: #168ec7;
		font-family: Alibaba Sans;
		font-weight: bold;
	}

	.el-icon-warning-outline {
		font-size: 18px;
		font-weight: bold;
		color: #1191cb;
	}
</style>
<style>
	.content-input-right-footer {
		background: #168ec7;
		display: inline-block;
		    line-height: 1;
		    white-space: nowrap;
		    cursor: pointer;
		    border: 1px solid #DCDFE6;
		    color: #ffffff;
		    -webkit-appearance: none;
		    text-align: center;
		    box-sizing: border-box;
		    outline: 0;
		    margin: 0;
		    transition: .1s;
		    font-weight: 500;
		    padding: 12px 20px;
		    font-size: 14px;
			border-radius: 20px;
			margin-bottom: 20px;
	}
	.content-input-right-footer:hover {
		margin-bottom: 20px;
		background: #168ec7;
		opacity: 0.8;
	}
	.content-input-right-top{
		    display: inline-block;
		    line-height: 1;
		    white-space: nowrap;
		    cursor: pointer;
		    background: #FFF;
		    border: 1px solid #DCDFE6;
		    color: #606266;
		    -webkit-appearance: none;
		    text-align: center;
		    box-sizing: border-box;
		    outline: 0;
		    margin: 0;
		    transition: .1s;
		    font-weight: 500;
		    padding: 12px 20px;
		    font-size: 14px;
	}
	.content-input-right-top:hover {
		opacity: 0.8;
	}
</style>
